import type { UseQueryResult } from 'react-query';
import { useQuery, useQueryClient, UseQueryOptions } from 'react-query';

import type { ApiError } from '~/lib/api';
import type { IApiGetAppsResponseBody } from '../AppsApi.types';
import { IQueryKeyFactory } from '~/helpers/types';
import { useApi } from '~/lib/api/useApi';
import { appQueryKeyFactory } from './useAppQuery';

export const appsQueryKeyFactory: IQueryKeyFactory = () =>
  ['apps', null] as const;

export const useAppsQuery = (
  options?: UseQueryOptions<IApiGetAppsResponseBody, ApiError>,
): UseQueryResult<IApiGetAppsResponseBody, ApiError> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: appsQueryKeyFactory(),
    queryFn: () => api.apps.getAll(),
    onSuccess: (apps) => {
      // For the moment, apps are not paginated and not filtered, so we can just
      // set the data for app queries.
      apps.items.forEach((app) => {
        queryClient.setQueryData(
          appQueryKeyFactory({
            appId: app._id,
          })!,
          app,
        );
      });
      options?.onSuccess?.(apps);
    },
    ...options,
  });
};
